import * as types from "../mutation-types";

// state
export const state = {
  tangle: null,
  strings: null,
  context: null,
};

// getters
export const getters = {
  context: (state) => state.context,
  check_context: (state) => state.context !== null,
};

// The former /api/v1/tangle, /api/v1/strings and /api/v1/context endpoints were removed;
// the welcome page gets the tangle data through window.tangle.
export const actions = {};

// mutations
export const mutations = {
  tangle(state, data)
  {
    return (state.tangle = data);
  },
  strings(state, data)
  {
    return (state.strings = data);
  },
  context(state, data)
  {
    state.context = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
